<template>
  <v-container fluid fill-height pa-0>
    <v-layout column fill-height ma-0 pa-1>
      <v-layout fill-height ma-0 pa-0 >
        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >

            <v-layout column fill-height justify-start ma-0 pa-0 >

                <div style="min-height: 140px; overflow-x: hidden;">
                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    manualSyncButton
                    @sync="(payload) => loadDeviceConfiguration(payload)"
                    @synchConfigures="(payload) => synchConfigures(payload)"
                    @manualSync="(payload) => onManualSync(payload)"
                    @select=""
                    @value=""
                  />
                </div>

              <v-layout column   pt-1>

                  <v-layout justify-start align-center class="customToolbar" pl-3>

                    <span v-if="!currentCommit && !mergeMode" class="white--text" >{{ $t('view configuration') }}</span>
                    <span v-if="currentCommit && !mergeMode" class="white--text" >{{ currentCommit.cls }} {{ currentCommit.date | moment("DD.MM.YYYY HH:mm:ss") }}</span>
                    <span v-if="currentCommit && mergeCommit && mergeMode " class="white--text" >{{ currentCommit.cls }} {{ currentCommit.date | moment("DD.MM.YYYY HH:mm:ss") }} -> {{ getMergeCommit.cls }} {{ getMergeCommit.date | moment("DD.MM.YYYY HH:mm:ss") }}</span>

                    <v-layout v-if="code" justify-end align-center pl-3>

                      <v-tooltip dark color="secondary" bottom>
                        <v-btn icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'add'"
                          v-if="!mergeMode && cmOptions.readOnly" 
                          @click.stop="dialog.configurations.show = true">
                          <svg-icon
                            :color="'white'"
                            :name="'add'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('open') }}</span>
                      </v-tooltip>
                      
                      <v-tooltip dark color="secondary" bottom>
                        <v-btn  icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'upload'"
                          v-if="!mergeMode && cmOptions.readOnly"
                          @click.stop="() => getConfigurationFile()">
                          <svg-icon
                            :color="'white'"
                            :name="'upload'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('export') }}</span>
                      </v-tooltip>

                      <v-tooltip dark color="secondary" bottom>
                        <v-btn  icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'merge'"
                          v-if="!mergeMode && cmOptions.readOnly"
                          @click.stop="() => onMerge()">
                          <svg-icon
                            :color="'white'"
                            :name="'merge'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('merge') }}</span>
                      </v-tooltip>

                      <v-tooltip dark color="secondary" bottom>
                        <v-btn  icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'download'"
                          v-if="!mergeMode && cmOptions.readOnly"
                          @click.stop="() => downloadDeviceConfiguration()">
                          <svg-icon
                            :color="'white'"
                            :name="'download'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('loading into device') }}</span>
                      </v-tooltip>

                      <v-tooltip v-if="!mergeMode && !cmOptions.readOnly" dark color="secondary" bottom>
                        <v-btn  icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'back'"
                          v-if="!mergeMode && !cmOptions.readOnly"
                          @click.stop="cmOptions.readOnly = !cmOptions.readOnly">
                          <svg-icon
                            :color="'white'"
                            :name="'back'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('back') }}</span>
                      </v-tooltip>

                      <v-tooltip v-if="code && !mergeMode && cmOptions.readOnly"  dark color="secondary" bottom>
                        <v-btn icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'edit'"
                          v-if="code && !mergeMode && cmOptions.readOnly" 
                          @click.stop="cmOptions.readOnly = !cmOptions.readOnly">
                          <svg-icon
                            :color="'white'"
                            :name="'edit'"
                            width="20"
                          />
                        </v-btn>
                        <span v-if="cmOptions.readOnly" class="caption">{{ $t('edit') }}</span>
                      </v-tooltip>

                      <v-tooltip dark color="secondary" bottom>
                        <v-btn  icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'done'"
                          v-if="code && !mergeMode && !cmOptions.readOnly"
                          @click.stop="() => commitConfig()">
                          <svg-icon
                            :color="'white'"
                            :name="'done'"
                            width="20"
                          />
                        </v-btn>
                        <span class="caption">{{ $t('commit') }}</span>
                      </v-tooltip>

                      <v-tooltip dark color="secondary" bottom>
                        <v-btn icon flat slot="activator" 
                          :data-testid="$options.name + '__btn__' + 'close'"
                          @click.stop="() => clear()">
                          <svg-icon
                            :color="'white'"
                            :name="'close'"
                            width="20"
                          />
                        </v-btn>
                        <span>{{ $t('close') }}</span>
                      </v-tooltip>
                    </v-layout>
                  </v-layout>

                  <v-layout fill-height  style="position: relative">

                    <codemirror v-if="code && !mergeMode" v-model="code" :options="cmOptions"></codemirror>
                    <codemirror v-if="show && mergeMode" :merge="true" :options="mergeOption" @scroll="onCmScroll"></codemirror> 

                    <v-layout v-if="!mergeMode"  fill-height  pa-1>
                      <v-layout column v-if="!getViewConfigurationLeft"  justify-center align-center>
                        <v-icon size="112" class="image-wrap" style="cursor: pointer;" 
                          v-if="!code"
                          :data-testid="$options.name + '__icon__' + 'control_point'"
                          @click="dialog.configurations.show = true">
                            control_point
                        </v-icon>
                      </v-layout>
                    </v-layout>

                    <v-dialog persistent v-model="dialog.configurations.show" max-width="70%" v-if="dialog.configurations.show">
                      <download-configuration-table
                        :data="getData"
                        @select="(payload) => loadConfiguration(payload)"
                        @onFileAdd="(payload) => onFileAdd(payload)"
                        @close="dialog.configurations.show = false"
                      />
                    </v-dialog>

                  </v-layout>

              </v-layout>

            </v-layout>

          </v-layout>
        </v-flex>

      </v-layout>

    </v-layout>

    <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show">
      <form-file-import
        :newFiles="dialog.upload.files"
        :activeObj="getData"
        :filetype="dialog.upload.filetype"
        @update="onConfTableUpdate()"
        @close="onFileImportClose()"
        @delete=""
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import downloadConfigurationTable from '@/nms/pages/configuration/fill-management/download-configuration-table.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/merge/merge.js'
import 'codemirror/addon/merge/merge.css'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/mode/vue/vue.js'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'
import DiffMatchPatch from 'diff-match-patch'

// Типы
interface MeasureItem {
  $id?: string
  measure_id?: string
  options?: any
  index?: number
  mirror?: {
    state?: string
    value?: any
    message?: string
    rt?: string
  }
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  align?: string
  actions?: Array<{
    title: string
    tooltip: string
    icon: string
    color: string
    emit: string
  }>
  fabIcon?: boolean | { title: string; tooltip: string; icon: string; color: string; emit: string }
}

interface TableData {
  columns: TableColumn[]
  rows: any[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface DialogState {
  configurations: { show: boolean }
  upload: {
    show: boolean
    filetype: string | null
    files: any[]
  }
}

interface ModelData {
  obj: {
    transmit_interval: number | null
    transmit_hold_multiplier: number | null
    reinitialization_delay: number | null
    notification_interval: number | null
  }
  addDevice: {
    vendor: string | null
    template: string | null
    user: string | null
    password: string | null
    disposition: string | null
    treeActive: any[]
    treeOpen: any[]
  }
}

interface CmOptions {
  tabSize: number
  styleActiveLine: boolean
  lineNumbers: boolean
  line: boolean
  foldGutter: boolean
  styleSelectedText: boolean
  mode: string
  keyMap: string
  matchBrackets: boolean
  showCursorWhenSelecting: boolean
  theme: string
  extraKeys: { [key: string]: string }
  hintOptions: { completeSingle: boolean }
  readOnly: boolean
}

interface MergeOption {
  tabSize: number
  value: string
  origLeft: string
  connect: string
  mode: string
  keyMap: string
  lineNumbers: boolean
  collapseIdentical: boolean
  highlightDifferences: boolean
  matchBrackets: boolean
  extraKeys: { [key: string]: string }
}

interface ConfigResponse {
  data?: {
    config?: string
    date?: string
  }
  count?: number
  [key: string]: any
}

interface CommitItem {
  $id?: string
  cls?: string
  [key: string]: any
}

interface DeviceData {
  $id?: string
  [key: string]: any
}

// Настройка DiffMatchPatch для глобального использования
;(window as any).diff_match_patch = DiffMatchPatch
;(window as any).DIFF_DELETE = -1
;(window as any).DIFF_INSERT = 1
;(window as any).DIFF_EQUAL = 0

export default Vue.extend({
  name: 'FILL_MANAGEMENT_CONFIGURATION',

  components: {
    scrollTable,
    downloadConfigurationTable,
    FormFileImport,
    svgIcon,
    codemirror,
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
  },

  data(): {
    fileClear: boolean
    measures: MeasureItem[]
    measuresStatuses: Record<string, any>
    lastR: ConfigResponse | null
    lastS: ConfigResponse | null
    sync_running_config: boolean
    sync_start_config: boolean
    sync_dolt_config: boolean
    count_running_config: boolean
    count_start_config: boolean
    mergeMode: boolean
    code: string
    currentCommit: CommitItem | null
    mergeCommit: CommitItem | null
    cmOptions: CmOptions
    mergeOption: MergeOption
    dialog: DialogState
    viewConfigurationLeft: any | null
    show: boolean
    model: ModelData
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      fileClear: false,
      measures: [],
      measuresStatuses: {},
      lastR: null,
      lastS: null,
      sync_running_config: true,
      sync_start_config: true,
      sync_dolt_config: true,
      count_running_config: true,
      count_start_config: true,
      mergeMode: false,
      code: '',
      currentCommit: null,
      mergeCommit: null,
      cmOptions: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        hintOptions: { completeSingle: false },
        readOnly: true
      },
      mergeOption: {
        tabSize: 0,
        value: '<p>hello</p>',
        origLeft: '<p>hello world</p>',
        connect: 'align',
        mode: 'text/javascript',
        keyMap: 'sublime',
        lineNumbers: true,
        collapseIdentical: false,
        highlightDifferences: true,
        matchBrackets: true,
        extraKeys: { Ctrl: 'autocomplete' }
      },
      dialog: {
        configurations: { show: false },
        upload: { show: false, filetype: null, files: [] },
      },
      viewConfigurationLeft: null,
      show: false,
      model: {
        obj: {
          transmit_interval: null,
          transmit_hold_multiplier: null,
          reinitialization_delay: null,
          notification_interval: null,
        },
        addDevice: {
          vendor: null,
          template: null,
          user: null,
          password: null,
          disposition: null,
          treeActive: [],
          treeOpen: [],
        }
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'configuration',
            value: 'configuration',
            type: 'text',
            width: '20%'
          },
          {
            title: 'number',
            value: 'number',
            type: 'text',
            width: '20%'
          },
          {
            title: 'last time update',
            value: 'last_time_update',
            type: 'timestamp',
            align: 'center',
            width: '30%',
          },
          {
            title: 'status',
            value: 'status$',
            type: 'text',
            width: '30%',
            actions: [
              {
                title: 'upload',
                tooltip: 'loading from device',
                icon: 'upload',
                color: 'green',
                emit: 'sync'
              },
            ],
            fabIcon: false
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },
    getMeasures(): MeasureItem[] {
      return this.measures
    },
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },
    getOptions(): OptionsData {
      return this.options
    },
    getViewConfigurationLeft(): any | null {
      return this.viewConfigurationLeft
    },
    getMergeCommit(): CommitItem | null {
      return this.mergeCommit
    },
  },

  watch: {
    data: {
      handler(): void {
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    onCmScroll(): void {
      console.log('onCmScroll')
    },

    async setup(): Promise<void> {
      this.reset()
      await this.loadMeasures()
      this.loadLastConfig()
    },

    async loadMeasures(): Promise<void> {
      try {
        this.statusUnsubscribe('fill_management_configuration')
        this.measures = []
        this.measuresStatuses = {}

        const meta = await this.$bridge.getMeta('measure')
        const optionsField = meta.fields.find((field: any) => field.name === 'options')
        const options: Record<string, boolean> = {}
        if (optionsField?.descriptor) {
          Object.keys(optionsField.descriptor).forEach(key => {
            options[key] = false
          })
        }

        this.setLoader('loadLastConfig', true)
        const objId = this.getData.$id
        console.log(this.$options.name, 'loadMeasures', 'objId', objId)

        const obj = await this.$bridge.getObjectById(objId)
        const measures = await obj.getMeasures(true, false) as MeasureItem[]
        console.log(this.$options.name, 'loadMeasures', 'measures$', measures)

        if (measures) {
          this.measures = measures.map((measure, i) => {
            if (!measure.options || Array.isArray(measure.options)) {
              measure.options = this.$merge({}, options)
              measure.index = i
              this.$set(this.measuresStatuses, measure.$id || '', measure.mirror)
            } else if (Object.keys(measure.options).length < 1) {
              measure.options = this.$merge({}, options)
              measure.index = i
              this.$set(this.measuresStatuses, measure.$id || '', measure.mirror)
            }
            return measure
          })
        }

        this.statusSubscribe(this.measures, 'fill_management_configuration')
        this.setLoader('loadLastConfig', false)
      } catch (error) {
        console.error(this.$options.name, 'loadMeasures', 'error', error)
        this.setLoader('loadLastConfig', false)
      }
    },

    async loadLastConfig(): Promise<void> {
      try {
        this.setLoader('loadLastConfig', true)

        this.lastR = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getConfigByCommit', {
          id: this.getData.$id,
          type: 'runningconfig',
          commit: 'last'
        }, 'get') as ConfigResponse

        if (this.lastR) {
          console.log(this.$options.name, 'loadLastConfig', 'lastR', this.lastR)
          const c = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getCountOfConfigs', {
            id: this.getData.$id,
            type: 'runningconfig',
          }, 'get') as ConfigResponse
          if (c) {
            console.log(this.$options.name, 'loadLastConfig', 'lastR c', c)
            this.$set(this.lastR, 'count', c.data)
          }
        }

        this.lastS = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getConfigByCommit', {
          id: this.getData.$id,
          type: 'startconfig',
          commit: 'last'
        }, 'get') as ConfigResponse

        if (this.lastS) {
          const c = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getCountOfConfigs', {
            id: this.getData.$id,
            type: 'startconfig',
          }, 'get') as ConfigResponse
          if (c) {
            this.$set(this.lastS, 'count', c.data)
          }
        }

        if (this.lastR && this.lastS) {
          this.createRows()
        }

        this.setLoader('loadLastConfig', false)
        console.log(this.$options.name, 'loadLastConfig', 'lastR', this.lastR)
        console.log(this.$options.name, 'loadLastConfig', 'lastS', this.lastS)
      } catch (error) {
        console.error(this.$options.name, 'loadLastConfig', 'error', error)
        this.setLoader('loadLastConfig', false)
      }
    },

    createRows(): void {
      const countRunningConfigMeasure = this.getMeasures.find(measure => measure.measure_id === 'count_running_config')
      const syncRunningConfigMeasure = this.getMeasures.find(measure => measure.measure_id === 'sync_running_config')
      const countStartConfigMeasure = this.getMeasures.find(measure => measure.measure_id === 'count_start_config')
      const syncStartConfigMeasure = this.getMeasures.find(measure => measure.measure_id === 'sync_start_config')
      const syncDoltConfigMeasure = this.getMeasures.find(measure => measure.measure_id === 'sync_dolt_config')

      const runningConfig = {
        configuration: 'runningconfig',
        number: this.lastR?.count || 'no data',
        last_time_update: this.lastR?.data?.date ? (this as any).$moment(this.lastR.data.date).format('DD.MM.YYYY HH:mm:ss') : 'no data',
        status: syncRunningConfigMeasure?.mirror?.state || 'sync',
        status$: syncRunningConfigMeasure?.mirror?.message || 'sync',
      }

      const startConfig = {
        configuration: 'startconfig',
        number: this.lastS?.count || 'no data',
        last_time_update: this.lastS?.data?.date ? (this as any).$moment(this.lastS.data.date).format('DD.MM.YYYY HH:mm:ss') : 'no data',
        status: syncStartConfigMeasure?.mirror?.state || 'sync',
        status$: syncStartConfigMeasure?.mirror?.message || 'sync',
      }

      if (syncDoltConfigMeasure?.mirror?.value === 2) {
        const actionsCol = this.table.columns.find(col => col.title === 'status')
        if (actionsCol) {
          actionsCol.fabIcon = {
            title: 'synchronize',
            tooltip: 'synchronize configurations',
            icon: 'settings',
            color: 'green',
            emit: 'synchConfigures'
          }
        }
      }

      this.table.rows = [runningConfig, startConfig]
    },

    async synchConfigures(payload: any): Promise<void> {
      console.log(this.$options.name, 'synchConfigures', 'payload', payload)
      if (!this.getData.$id) return

      try {
        this.setLoader('synchConfigures', true)
        const synch = await this.$bridge.customQuery('alarm', '/switch_settings/swset/execCommand', { id: this.getData.$id, name: 'write' }, 'post')
        if (synch) {
          this.setup()
        }
        this.setLoader('synchConfigures', false)
      } catch (error) {
        console.error(this.$options.name, 'synchConfigures', 'error', error)
        this.setLoader('synchConfigures', false)
      }
    },

    async loadConfiguration(commit: CommitItem): Promise<void> {
      if (!commit?.$id || !commit.cls) return

      try {
        this.$set(this.dialog.configurations, 'show', false)
        this.setLoader('loadConfiguration', true)

        const configuration = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getConfigByCommit', {
          id: this.getData.$id,
          type: commit.cls,
          commit: commit.$id,
        }, 'get') as ConfigResponse

        console.log(this.$options.name, 'loadConfiguration', 'configuration', configuration)

        if (configuration?.data?.config) {
          if (this.mergeMode) {
            this.mergeCommit = commit
            this.$set(this.mergeOption, 'origLeft', configuration.data.config)
            this.show = true
          } else {
            this.currentCommit = commit
            this.code = configuration.data.config
          }
        }
        this.setLoader('loadConfiguration', false)
      } catch (error) {
        console.error(this.$options.name, 'loadConfiguration', 'error', error)
        this.setLoader('loadConfiguration', false)
      }
    },

    async loadDeviceConfiguration(row: any): Promise<void> {
      if (!row?.configuration) return

      try {
        this.setLoader('loadDeviceConfiguration', true)
        console.log(this.$options.name, 'loadDeviceConfiguration row', row)

        const r = await this.$bridge.customQuery('alarm', 'switch_settings/swset/deviceConfig', {
          id: this.getData.$id,
          method: 'put',
          conf: row.configuration,
        }, 'post')
        this.setLoader('loadDeviceConfiguration', false)
      } catch (error) {
        console.error(this.$options.name, 'loadDeviceConfiguration', 'error', error)
        this.setLoader('loadDeviceConfiguration', false)
      }
    },

    async downloadDeviceConfiguration(): Promise<void> {
      if (!this.currentCommit?.cls) return

      try {
        this.setLoader('downloadDeviceConfiguration', true)
        console.log(this.$options.name, 'downloadDeviceConfiguration')

        const r = await this.$bridge.customQuery('alarm', 'switch_settings/swset/deviceConfig', {
          id: this.getData.$id,
          method: 'get',
          conf: 'startconfig',
        }, 'post')
        this.setLoader('downloadDeviceConfiguration', false)
      } catch (error) {
        console.error(this.$options.name, 'downloadDeviceConfiguration', 'error', error)
        this.setLoader('downloadDeviceConfiguration', false)
      }
    },

    async getConfigurationFile(): Promise<void> {
      try {
        this.setLoader('getConfigurationFile', true)
        console.log(this.$options.name, 'getConfigurationFile', 'this.currentCommit', this.currentCommit)

        const id = this.getData.$id
        const configtype = this.currentCommit?.cls
        const commit = this.currentCommit?.$id

        const r = await this.$bridge.customQuery('alarm', 'switch_settings/swset/getConfigFile', {
          id, configtype, commit,
        }, 'get')

        this.$store.dispatch('file/download/save', {
          content: r,
          filename: id + configtype + '.cfg'
        })

        console.log(this.$options.name, 'getConfigurationFile r', r)
        this.setLoader('getConfigurationFile', false)
      } catch (error) {
        console.error(this.$options.name, 'getConfigurationFile', 'error', error)
        this.setLoader('getConfigurationFile', false)
      }
    },

    async commitConfig(): Promise<void> {
      if (!this.code || !this.currentCommit?.cls) return

      try {
        this.setLoader('commitConfig', true)
        console.log(this.$options.name, 'commitConfig')

        const r = await this.$bridge.customQuery('alarm', 'switch_settings/swset/sendConfigToDolt', {
          id: this.getData.$id,
          configtype: this.currentCommit.cls,
          config: this.code,
        }, 'post')
        console.log(this.$options.name, 'commitConfig r', r)

        this.$set(this.cmOptions, 'readOnly', true)
        this.setLoader('commitConfig', false)
      } catch (error) {
        console.error(this.$options.name, 'commitConfig', 'error', error)
        this.setLoader('commitConfig', false)
      }
    },

    onFileAdd(payload: { file: { target: { files: FileList } }; filetype: string }): void {
      const e = payload.file
      console.log(this.$options.name, 'onFileAdd', 'payload', payload)
      console.log(this.$options.name, 'onFileAdd', 'e', e)

      if (!e.target.files.length) return
      console.log(this.$options.name, 'onFileAdd', 'payload', e.target.files)

      Array.from(e.target.files).forEach(file => {
        this.dialog.upload.files.push(file)
      })
      this.dialog.upload.filetype = payload.filetype
      this.dialog.upload.show = true
      this.fileClear = true
      this.$nextTick(() => {
        this.fileClear = false
      })
    },

    onConfTableUpdate(): void {
      this.dialog.configurations.show = false
      setTimeout(() => this.$set(this.dialog.configurations, 'show', true), 500)
    },

    onFileImportClose(): void {
      this.$set(this.dialog.upload, 'show', false)
      this.$set(this.dialog.upload, 'filetype', null)
      this.$set(this.dialog.upload, 'files', [])
    },

    async onMerge(): Promise<void> {
      try {
        console.log(this.$options.name, 'onMerge START')
        this.mergeMode = true
        this.$set(this.dialog.configurations, 'show', true)
        this.$set(this.mergeOption, 'value', this.code)
      } catch (error) {
        console.error(this.$options.name, 'onMerge', 'error', error)
        this.setLoader('loadConfiguration', false)
      }
    },

    async onManualSync(payload: any): Promise<void> {
      try {
        console.log(this.$options.name, 'onManualSync', 'payload', payload)
        this.setLoader('onManualSync', true)

        await this.$bridge.customQuery('alarm', 'switch_settings/swset/checkSyncDoltForDevice', { id: this.getData.$id, configtype: 'runningconfig' }, 'post')
        await this.$bridge.customQuery('alarm', 'switch_settings/swset/checkSyncDoltForDevice', { id: this.getData.$id, configtype: 'startconfig' }, 'post')
        await this.$bridge.customQuery('alarm', 'switch_settings/swset/checkSyncStartAndRunningForDevice', { id: this.getData.$id }, 'post')
        // await this.$bridge.customQuery('alarm', '/switch_settings/swset/checkSyncDoltForDevice', { device: this.getData.$id, configtype: 'runningconfig' }, 'post')
        // await this.$bridge.customQuery('alarm', '/switch_settings/swset/checkSyncDoltForDevice', { device: this.getData.$id, configtype: 'startconfig' }, 'post')
        // await this.$bridge.customQuery('alarm', '/switch_settings/swset/checkSyncStartAndRunningForDevice', { device: this.getData.$id }, 'post')

        this.setLoader('onManualSync', false)
      } catch (error) {
        console.error(this.$options.name, 'onManualSync', 'error', error)
        this.setLoader('onManualSync', false)
      }
    },

    clear(): void {
      this.show = false
      this.code = ''
      this.$set(this.mergeOption, 'origLeft', '')
      this.mergeMode = false
      this.currentCommit = null
      this.mergeCommit = null

      this.cmOptions = {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        foldGutter: true,
        styleSelectedText: true,
        mode: 'text/javascript',
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        hintOptions: { completeSingle: false },
        readOnly: true
      }
    },

    async statusSubscribe(arr: any[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })

      if (arr.length) {
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    async subscribeHandler(e: { $id?: string; state?: string; value?: any; message?: string; rt?: string; [key: string]: any }): Promise<void> {
      this.$store.dispatch('addStatus', e)

      if (e?.$id) {
        const f = this.getMeasures.find(measure => measure.$id === e.$id)
        if (f) {
          if (e.state) this.$set(f.mirror, 'state', e.state)
          if (e.value) this.$set(f.mirror, 'value', e.value)
          if (e.message) this.$set(f.mirror, 'message', e.message)
          if (e.rt) this.$set(f.mirror, 'rt', e.rt)

          if ((this as any)[f.measure_id || '']) {
            this.createRows()
          }
        }
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.table = {
        columns: [
          {
            title: 'configuration',
            value: 'configuration',
            type: 'text',
            width: '20%'
          },
          {
            title: 'number',
            value: 'number',
            type: 'text',
            width: '20%'
          },
          {
            title: 'last time update',
            value: 'last_time_update',
            type: 'timestamp',
            align: 'center',
            width: '30%',
          },
          {
            title: 'status',
            value: 'status$',
            type: 'text',
            width: '30%',
            actions: [{
              title: 'upload',
              tooltip: 'loading from device',
              icon: 'upload',
              color: 'green',
              emit: 'sync'
            }],
            fabIcon: false
          },
        ],
        rows: []
      }
    },
  },
})
</script>

<style lang="css" scoped>

.hide_plus {
  position: relative;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-flex;
  display: flex;
  height: 100%;
  justify-content: center;
  opacity: .2;
}

.image-wrap {
  box-sizing: border-box;
  color: grey;
  opacity: 1;
}

.image-wrap:hover {
  /* color: white; */
  opacity: .5;
}
.customToolbar {
  background-color: #58595B;
  height: 48px;
  font-size: 20px;
  font-weight: 500;
}

.CodeMirror cm-s-monokai {
  height: 100% !important;
  min-height: 100% !important;
  position: absolute !important;
}

.vue-codemirror {
  height: 100%;
  width: 100%;
  position: relative;
}

/* .CodeMirror-merge-2pane .CodeMirror-merge-pane {
    width: 40%;
} */

</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
